import { render, staticRenderFns } from "./out_store.vue?vue&type=template&id=6c7f01c9&scoped=true"
import script from "./out_store.vue?vue&type=script&lang=js"
export * from "./out_store.vue?vue&type=script&lang=js"
import style0 from "./out_store.vue?vue&type=style&index=0&id=6c7f01c9&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7f01c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c7f01c9')) {
      api.createRecord('6c7f01c9', component.options)
    } else {
      api.reload('6c7f01c9', component.options)
    }
    module.hot.accept("./out_store.vue?vue&type=template&id=6c7f01c9&scoped=true", function () {
      api.rerender('6c7f01c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/visit_detail/components/out_store.vue"
export default component.exports